module.exports = __webpack_public_path__ + "static/media/ProximaNova-Bold.1518c31b.ttf";